var BASE_API; // IAM
var AUDITSX_BASE_API; // auditsx

if (process.env.NODE_ENV === "development") {
  // BASE_API = "http://localhost:3002";
  // AUDITSX_BASE_API = "http://localhost:3002";
  BASE_API = process.env.REACT_APP_IAM_BASE_API;
  AUDITSX_BASE_API = process.env.REACT_APP_AUDITSX_BASE_API;
} else if (process.env.NODE_ENV === "production") {
  BASE_API = process.env.REACT_APP_IAM_BASE_API;
  AUDITSX_BASE_API = process.env.REACT_APP_AUDITSX_BASE_API;
}

export var BASE_API;
export var AUDITSX_BASE_API;
